import React, { Component } from 'react'

export default class Slider extends Component {
  componentDidMount() {
    const video = document.getElementById('banner-video');
    if (video) {
      video.play().catch(err => {
        console.log('Otomatik oynatma engellendi:', err);
      });
    }
  }

  render() {
    return (
      <div style={{ position: 'relative', width: '100%', height: '500px', overflow: 'hidden' }}>
        <div style={{
            backgroundColor: 'rgba(77, 184, 205, 0.28)',
            position: 'absolute',
            top: 0, 
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1

        }}></div>
        <video 
          id="banner-video" 
          controlsList="nodownload" 
          muted 
          preload="auto" 
          loop 
          autoPlay
          playsInline
          src="/Assets/img/video.mp4"
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            minWidth: '100%',
            minHeight: '100%',
            width: 'auto',
            height: 'auto',
            transform: 'translate(-50%, -50%)',
            objectFit: 'cover',
            zIndex: 0
          }}
        />
        
        {/* İçerik Katmanı */}
        <div style={{ 
          position: 'relative', 
          zIndex: 99, 
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          padding: '20px'
        }}>
          <div style={{
            backgroundColor: 'rgba(224, 247, 250, 0.9)',
            padding: '8px 16px',
            borderRadius: '20px',
            marginBottom: '20px',
            fontSize: '12px',
            color: '#4db8cd',
            fontWeight: '500',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px'
          }}>
            GLOBAL TRAVEL PLATFORM
          </div>

          <h1 style={{
            fontSize: '48px',
            fontWeight: '700',
            margin: '0 0 10px 0',
            lineHeight: '1.2'
          }}>
            <span style={{ color: '#4db8cd' }}>Operate Smarter</span>
            <br />
            <span style={{ color: '#1a1a1a' }}>And Sell More</span>
          </h1>

          <p style={{
            color: '#fff',
            fontSize: '16px',
            maxWidth: '600px',
            margin: '0 0 30px 0',
            lineHeight: '1.6'
          }}>
            We Help Tour & Activity Providers Digitize, Manage, And Sell Their
            Products Across All Sales Channels From A Single Platform.
          </p>

          <div style={{ display: 'flex', gap: '15px' }}>
            <button style={{
              backgroundColor: '#4db8cd',
              color: 'white',
              border: 'none',
              padding: '12px 30px',
              borderRadius: '6px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer'
            }}>
              Get Started
            </button>
            <button style={{
              backgroundColor: 'white',
              color: '#1a1a1a',
              border: '2px solid #e0e0e0',
              padding: '12px 30px',
              borderRadius: '6px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer'
            }}>
              Login
            </button>
          </div>
        </div>
      </div>
    )
  }
}